import { getConfig } from "../config";

/**
 * Runs inside the Office dialog after the OIDC redirect completes.
 * Fetches the auth token from the backend (the browser sends the HttpOnly
 * cookie automatically) and sends it back to the parent taskpane via
 * `Office.context.ui.messageParent`.
 */
export async function handleDialogCallback(): Promise<void> {
  const config = getConfig();
  const token = await fetchToken(config.apiBaseUrl);
  if (token) {
    Office.context.ui.messageParent(JSON.stringify({ type: "auth-complete", token }));
  } else {
    // TODO: Handle error
    Office.context.ui.messageParent(JSON.stringify({ type: "auth-complete" }));
  }
}

async function fetchToken(apiBaseUrl: string): Promise<string | null> {
  try {
    const response = await fetch(`${apiBaseUrl}/api/auth/token`, {
      credentials: "include",
    });
    if (!response.ok) return null;
    const body = await response.json();
    return body.token ?? null;
  } catch {
    return null;
  }
}
